// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ComponentNavigation-providerBase__M5EBZ{width:var(--size-full);height:var(--size-full)}.ComponentNavigation-base__dfwKf{position:relative;width:var(--size-full);height:var(--size-full)}.ComponentNavigation-componentContainer__BTEUr{position:relative;width:var(--size-full);height:var(--size-full);max-height:calc(none - 0px);max-height:calc(var(--popover-viewport-height, none) - var(--popover-drag-indicator-height, 0px));overflow:hidden;transition:height var(--duration-slow)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"providerBase": "ComponentNavigation-providerBase__M5EBZ",
	"base": "ComponentNavigation-base__dfwKf",
	"componentContainer": "ComponentNavigation-componentContainer__BTEUr"
};
export default ___CSS_LOADER_EXPORT___;
